export default {
  resendId: 'ID замовлення для повторної подачі',
  resendBtn: 'повторно відправити замовлення',
  newVerSoft: 'Надіслати інформацію про нову версію програми',
  menu: 'Меню',
  thumbs: 'створювати мініатюри',
}
